<template>
  <div class="header">
    <div class="header-brand">
      <div class="relative d-flex w-100 h-100 align-items-center justify-content-center">
        <img src="../assets/img/logo_demo.svg" />
        <a class="btn-logout-mobile" href="/">
          <img :src="logOut"/>
        </a>
      </div>
    </div>
    <div class="header-tabs bg-gradient">
      <div class="relative d-flex w-100 h-100 justify-content-center align-items-center">
        <router-link
          class="btn-tab px-3 d-flex justify-content-center"
          v-for="(value, index) in tabs"
          :key="index"
          :to="value.href"
          v-bind:class="{ 'btn-tab-active': value.isActive }"
          v-on:click.native="change(index)"
        >
          <span class="mr-2 d-flex align-items-center" v-html="value.img"></span>
          {{ value.title }}
        </router-link>
        <a class="btn-logout" href="/" @click.prevent="logout">
          <span>離開</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
// import uploadIcon from "../assets/img/icon/upload.svg";
import uploadIconActive from "../assets/img/icon/upload_yellow.svg";
// import recordIcon from "../assets/img/icon/record.svg";
//import recordIconActive from "../assets/img/icon/record_yellow.svg";
// import verifyIcon from "../assets/img/icon/verify.svg";
import verifyIconActive from "../assets/img/icon/verify_yellow.svg";
import logOutIcon from '../assets/img/icon/log-out.png';

export default {
  name: "NavBar",
  // template: ".header",
  props:{
    testTabs:Array,
  },
  data(){
    return{
      logOut:logOutIcon,
      tabs: [
        {
          img:`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.43782 4.78868L8 1.57735L13.5622 4.78868V11.2113L8 14.4226L2.43782 11.2113V4.78868Z" stroke="white" stroke-linejoin="round"/>
              <path d="M10 10L8 8L6 10" stroke="white" stroke-linecap="round"/>
              <path d="M8 9V15" stroke="white" stroke-linecap="round"/>
          </svg>
          `,
          activeImg: uploadIconActive,
          title: "存證證據",
          href: "/upload",
          isActive: true,
        },
        {
          img:`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.43782 4.78868L8 1.57735L13.5622 4.78868V11.2113L8 14.4226L2.43782 11.2113V4.78868Z" stroke="white" stroke-linejoin="round"/>
          <path d="M5 7L8 10L14 3" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          `,
          activeImg:verifyIconActive,
          title: "驗證證據",
          href: "/verify",
          isActive: false,
        },
      ],
      test:'fromchild'
    }
  },
  methods: {
    change(key){
      this.tabs.forEach(element => {
        element.isActive = false
      });
      this.tabs[key].isActive = true;
      this.$emit("value-update",this.test);
    },
    logout(){
      sessionStorage.clear();
      this.$router.push('/');
    }
  },
};
</script>

<style scoped>
</style>
